"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typings_1 = require("../typings");
function logClick(data) {
    return data ? { event: typings_1.BaobabLogEventType.Click, data: data } : { event: typings_1.BaobabLogEventType.Click };
}
exports.logClick = logClick;
function logScroll(data) {
    return data ? { event: typings_1.BaobabLogEventType.Scroll, data: data } : { event: typings_1.BaobabLogEventType.Scroll };
}
exports.logScroll = logScroll;
function logTech(type, data) {
    return data ? { event: typings_1.BaobabLogEventType.Tech, type: type, data: data } : { event: typings_1.BaobabLogEventType.Tech, type: type };
}
exports.logTech = logTech;
